import script from "./IntestationHero.vue?vue&type=script&setup=true&lang=js"
export * from "./IntestationHero.vue?vue&type=script&setup=true&lang=js"

import "./IntestationHero.vue?vue&type=style&index=0&id=3e8c426c&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e8c426c"]])

export default __exports__